module.exports = __webpack_public_path__ + "media/images/admin/favicons/favicon-16x16-1197d27058eb488cef1d5694f7598d28.png";